class ShippingLocationDrawer {
  constructor() {
    this.drawer = document.getElementById('ShippingLocationDrawer');
    this.toggleButtons = document.querySelectorAll('.shipping-location-button');
    this.closeButton = this.drawer?.querySelector('.drawer__close');
    this.overlay = document.getElementById('ShippingLocationDrawer-Overlay');
    
    this.init();
  }
  
  init() {
    if (!this.drawer) return;
    
    // Add event listeners to toggle buttons
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', this.toggleDrawer.bind(this));
    });
    
    // Add event listener to close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeDrawer.bind(this));
    }
    
    // Add event listener to overlay
    if (this.overlay) {
      this.overlay.addEventListener('click', this.closeDrawer.bind(this));
    }
    
    // Add event listener for ESC key to close drawer
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeDrawer();
      }
    });
  }
  
  toggleDrawer(event) {
    event.preventDefault();
    
    if (this.drawer.classList.contains('active')) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }
  
  openDrawer() {
    if (!this.drawer) return;
    
    this.drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }
  
  closeDrawer() {
    if (!this.drawer) return;
    
    this.drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

// Initialize the shipping location drawer when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ShippingLocationDrawer();
});
